import { useMemo } from "react"
//check if in this shoot there is at least one go to team user
const useHaveGTT = usersRolesArray => {
  return useMemo(
    () => {
      return (
        usersRolesArray.filter(x => x.user_company === "Go To Team").length > 0
      )
    },
    [usersRolesArray]
  )
}

export default useHaveGTT
